




























































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, } from 'vue-property-decorator';
import { BlockoutPeriod, ApiError, Extra } from '@/api';
import { snackModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import DatePicker from '@/components/DatePicker.vue';

@Component({
    components: {
        ConfirmDialog,
        DatePicker,
    },
})
export default class extends Vue {
    @Prop({ required: false }) readonly routeTitle: string;

    loading: boolean = false;
    valid: boolean = false;
    complete: boolean = false;
    error: string = '';

    blockoutPeriod: BlockoutPeriod | null = null;
    supportedBlockTypes = BlockoutPeriod.supportedBlockTypes
    extras: Extra[] = [];
    extraIds: string[] = [];

    nextFn: (() => void) | null = null;
    leaveConfirmDialog: boolean = false;
    confirmLeaveContent: string =
        'Are you sure you would like to leave? Any unsaved changes will be lost.';

    requiredString = [
        (v: string) =>
            v8n()
                .string()
                .not.empty()
                .test(v) || 'This field is required',
    ];

    requiredRate = [
        (v: string) =>
            v8n()
                .number()
                .between(0, 100)
                .test(Number(v)) || 'Must be a number between 0 and 100',
    ];

    get blockoutPeriodId() {
        return this.$route.params.blockoutPeriodId;
    }

    back() {
        this.$router.back();
    }

    beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
        if (this.blockoutPeriod && this.blockoutPeriod.isDirty()) {
            this.nextFn = next;
            this.leaveConfirmDialog = true;
            next(false);
        } else {
            next();
        }
    }

    leave() {
        if (this.nextFn) {
            this.nextFn();
        }
    }

    async save() {
        if (!this.blockoutPeriod) {
            return;
        }

        try {
            if (this.blockoutPeriod.blockType !== 'extra') this.extraIds = [];
            this.blockoutPeriod.extras = this.extras.filter(({id}) => this.extraIds.includes(id as string));
            await this.blockoutPeriod.save({with: ['extras.id']});
            if (
                this.$route.name === 'admin-blockout-periods-add' &&
                this.blockoutPeriod &&
                this.blockoutPeriod.id
            ) {
                this.$router.push({
                    name: 'admin-blockout-periods-edit',
                    params: { blockoutPeriodId: this.blockoutPeriod.id },
                });
                snackModule.showSnackbar('Blockout Period Created');
            } else {
                snackModule.showSnackbar('Blockout Period Updated');
            }
        } catch (err) {
            err.response.errors.forEach((e: ApiError) =>
                snackModule.showSnackbar(e.detail),
            );
        }
    }

    async mounted() {
        this.extras = (await Extra.all()).data;
        if (this.$route.name === 'admin-blockout-periods-edit' && this.blockoutPeriodId) {
            try {
                this.blockoutPeriod = (await BlockoutPeriod.find(this.blockoutPeriodId)).data;
                this.extraIds = this.blockoutPeriod.extras.map(({id}) => id as string);
            } catch (err) {
                // most likely this means not found
                snackModule.showSnackbar('Blockout Period not found');
            }
        } else {
            this.blockoutPeriod = new BlockoutPeriod();
        }
    }
}
